import { useEffect, useState } from "react";
import { AcademyService } from "../../../Component/Api/Academy/AcademyService";
import { DataTable } from "../../../Component/Common/Components/DataTable/DataTable";
import { SmallLoading } from "../../../Component/Common/Components/Loading/IntermediateLoading";
import { DigitalContentSectionItem } from "../../../Component/Model/Dto/Academy";
import { EntriesPerPage } from "../../../Component/Model/Table/Table";
import { DigitalContentSectionTableMapper } from "./DigitalContentSectionColumns";

interface IProps {
    sectionId: number;
}

export const DigitalContentSectionDataTable = (props: IProps) => {

    const [digitalContentSectionItemsData, setDigitalContentSectionItemsData] = useState<DigitalContentSectionItem.DtoIn[]>([]);
    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [searchValue, setSearchValue] = useState<string>('');
    const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const searchValueChanged = (value: string) => {
        setSearchValue(value);
    }

    const fetchSectionItems = async (sectionId: number) => {
        const sectionItemsSearchRequest: DigitalContentSectionItem.SearchRequest = {
            Draw: 2,
            PageNumber: pageNumber,
            PageSize: entriesPerPage.defaultValue as number,
            SearchValue: searchValue,
            SectionId: sectionId
        }
        setIsLoading(true);
        try {
            let response = await AcademyService.SearchDigitalContentSectionItems(sectionItemsSearchRequest);
            setDigitalContentSectionItemsData(response.data.results);
            setFilteredItemsCount(response.data.filteredItemsCount);
            setTotalItemsCount(response.data.totalItemsCount);
        }
        catch (error) {
            console.error("Unable to retrieve Digital Content search results");
        }
        finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchSectionItems(props.sectionId);
    }, [entriesPerPage, pageNumber, searchValue]); // eslint-disable-line react-hooks/exhaustive-deps

    const sectionTableData = DigitalContentSectionTableMapper(digitalContentSectionItemsData);

    return (
        <>
            <DataTable
                table={sectionTableData}
                entriesPerPage={entriesPerPage}
                pageNumber={pageNumber}
                filteredItemsCount={filteredItemsCount}
                totalItemsCount={totalItemsCount}
                entriesPerPageChanged={entriesPerPageChanged}
                pageNumberChanged={pageNumberChanged}
                isLoading={isLoading}
                canSearch={true}
                searchValueChanged={searchValueChanged}
            ></DataTable>
        </>
    )
}
